/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from 'react';
import { ExpandMoreRounded, Search } from '@mui/icons-material';
import {
  Box, Button, Divider, Grid, MenuItem, Pagination, Select, Skeleton, Snackbar, Stack, TextField,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import Images from '../../../../Configs/images';
import Elements from '../../../Elements';
import ROUTES from '../../../../Configs/routes';
import { getAdminItemList } from '../../../../Redux/Models/market';
import AlertContext from '../../../../Context/AlertContext';
import { OverviewCard } from '../Overview/Overview';
import { formatNumToCurrency } from '../../../../Utils/helpers';

export default function Market({
  data, classes, error, message, isLoading, totalPage = 1, currentPage = 1, overview,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { openAlert } = useContext(AlertContext);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sort, setSort] = useState('Newest');
  const [saleType, setSaleType] = useState('all');
  const [keyword, setKeyword] = useState('');
  const [column, setColumn] = useState(2);

  const { auction, on_sale, fixed_price } = overview;

  const getData = () => {
    dispatch(getAdminItemList({ limit, page, sale_type: saleType === 'all' ? '' : saleType }));
  };

  useEffect(() => {
    getData();
  }, [limit, page, saleType]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (page === 1) {
        getData();
      } else {
        setPage(1);
      }
    }, 1500);

    return () => clearTimeout(delayDebounceFn);
  }, [keyword]);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  const renderItems = () => {
    if (isLoading) {
      return (
        <Grid container spacing={2}>
          {new Array(3).fill(0).map((l, idx) => (
            <Grid item xs={12 / column} key={idx}>
              <Box display="flex" gap={1.5} border="1px solid #E5E5E5" borderRadius="5px" p={2}>
                <Skeleton variant="rectangular" height={80} width={80} />
                <Box flex={1}>
                  <Box className="weight-600">
                    <Skeleton variant="text" width="80%" />
                  </Box>
                  <Box display="flex" className="s-10" color="#586479" gap={0.5} flexWrap="wrap" alignItems="center" mt={0.25}>
                    <Skeleton variant="text" width="100%" />
                    <Skeleton variant="text" width="80%" />
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                    <Box className="s-16 weight-700">
                      <Skeleton variant="text" width="50%" />
                    </Box>
                    <Box display="flex" gap={0.5}>
                      <Skeleton variant="text" width="20%" />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      );
    }
    if (data.length) {
      return (
        <Grid container spacing={2}>
          { data.map((item, index) => (
            <Grid item xs={12 / column} key={item.id}>
              <Box display="flex" gap={1.5} onClick={() => navigate(`${ROUTES.market()}/detail/${item.id}`)} key={index} border="1px solid #E5E5E5" borderRadius="5px" p={2}>
                <img
                  width="80px"
                  height="80px"
                  className="rounded cover"
                  src={item.photo}
                  alt="baco"
                />
                <Box flex={1}>
                  <Box className="weight-600">{item.name}</Box>
                  <Box display="flex" className="s-10" color="#586479" gap={0.5} flexWrap="wrap" alignItems="center" mt={0.25}>
                    <div>{item.category?.name || '-'}</div>
                    <div>
                      ・
                      {item.condition?.name || '-'}
                    </div>
                    <div>
                      ・
                      {item.volume || '0 mL'}
                    </div>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                    <Box className="s-16 weight-700">
                      {formatNumToCurrency(Number(item.price))}
                    </Box>
                    <Box display="flex" gap={0.5}>
                      {
                        item?.is_sale ? <Box fontSize={12}>Qty 1</Box>
                          : <Box fontSize={12}>Not In Market</Box>
                      }
                      <img src={Images.CheckRed} alt="check-icon" />
                    </Box>
                  </Box>
                  {item.sale_type === 'Bid Price'
                    && (
                    <Box className="s-12" mt={0.5}>
                      {item.bidder_count}
                      {' '}
                      bids・
                      {moment(item.end_date).format('DD MMM YYYY (HH.mm)')}
                    </Box>
                    )}
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      );
    }

    return (
      <div className="s-16 mt-5 center">
        <img src={Images.Sure} alt="No data" />
        <div className="weight-700 mt-4">Market items will appear in here soon</div>
        <div className="mt-3">Check again later</div>
      </div>
    );
  };

  return (
    <Elements.AdminPageBase navigate={navigate}>
      <div className={classes.root}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box fontSize={20}>
            <strong>My Items</strong>
          </Box>
          <Box display="flex" alignItems="center" gap={3}>
            {/* <Box
              display="flex"
              alignItems="center"
              gap={1}
              py={1}
              px={2}
              bgcolor="#FDFDFD"
              borderRadius="10px"
              border="1px solid #E5E5E5"
              className="link"
              fontSize={14}
            >
              <img src={Images.Download} alt="download" height="20" width="20" />
              Download Order Report
            </Box> */}
            <Button className="btn-contained" size="small" sx={{ px: 2 }} onClick={() => navigate(`${ROUTES.market()}/create`)}>Sale Item</Button>
          </Box>
        </Box>
        <Box mt={3} borderRadius="10px" bgcolor="#FDFDFD" p={2}>
          <Box className="weight-600">My Items Overview</Box>
          <Stack direction="row" spacing={2} mt={2}>
            <OverviewCard
              title="Total My Items On Sale"
              value={auction.total + fixed_price.total + on_sale.total}
              desc="from last 1 month"
              image={Images.OenoBox}
            />
            <OverviewCard
              title="Total Fixed Price"
              value={fixed_price.total}
              percentage={fixed_price.percent}
              desc="from last 1 month"
              image={Images.OenoCurrency}
            />
            <OverviewCard
              title="Total In Auction"
              value={auction.total}
              percentage={auction.percent}
              desc="from last 1 month"
              image={Images.OenoHammer}
            />
            <OverviewCard
              title="Total Sold Item"
              value={on_sale.total}
              percentage={on_sale.percent}
              desc="from last 1 month"
              image={Images.OenoMarket}
            />
          </Stack>
        </Box>

        <Box mt={2} className="flex gap-16 space-between">
          <Box display="flex" gap={1}>
            <Select
              select
              value={saleType}
              size="small"
              onChange={({ target }) => setSaleType(target.value)}
              IconComponent={ExpandMoreRounded}
              sx={{
                borderRadius: '10px',
                bgcolor: '#fff',
              }}
            >
              <MenuItem value="all">All Type</MenuItem>
              <MenuItem value="Fixed Price">Fixed Price</MenuItem>
              <MenuItem value="Auction">Bid Price/Auction</MenuItem>
            </Select>
          </Box>
          <Box display="flex" gap={2}>
            <Select
              select
              size="small"
              value={sort}
              onChange={({ target }) => setSort(target.value)}
              IconComponent={ExpandMoreRounded}
              sx={{
                borderRadius: '10px',
                bgcolor: '#fff',
              }}
            >
              <MenuItem value="Oldest">Oldest</MenuItem>
              <MenuItem value="Newest">Newest</MenuItem>
            </Select>
            <Select
              select
              size="small"
              value={limit}
              onChange={({ target }) => setLimit(target.value)}
              IconComponent={ExpandMoreRounded}
              sx={{
                borderRadius: '10px',
                bgcolor: '#fff',
              }}
            >
              <MenuItem value={10}>10 List</MenuItem>
              <MenuItem value={20}>20 List</MenuItem>
              <MenuItem value={50}>50 List</MenuItem>
            </Select>
            <TextField
              placeholder="Search by keyword"
              size="small"
              sx={{
                ' .MuiInputBase-root': {
                  bgcolor: '#fff',
                },
              }}
              value={keyword}
              onChange={({ target }) => setKeyword(target.value)}
              InputProps={{
                startAdornment: (<Search fontSize="small" sx={{ mr: 1, color: '#D4D4D4' }} />),
              }}
            />
          </Box>
        </Box>

        <Box display="flex" justifyContent="space-between" mt={2}>
          <Box fontSize={12} color="#586479">
            <strong>{data.length}</strong>
            {' '}
            items
          </Box>
          <Box display="flex" alignItems="center" gap={2}>
            <Pagination
              count={totalPage}
              variant="outlined"
              shape="rounded"
              size="small"
              page={!isLoading ? currentPage : page}
              siblingCount={0}
              onChange={(e, newPage) => setPage(newPage)}
            />
            <Divider orientation="vertical" flexItem />
            <Box display="flex" alignItems="center" gap={1}>
              {[2, 3].map((val) => (
                <Box
                  key={val}
                  border={val !== column ? '1px solid #E5E5E5' : ''}
                  bgcolor={val === column ? '#38AC3D' : 'none'}
                  boxSizing="border-box"
                  borderRadius="5px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  width={24}
                  height={24}
                  color={val === column ? '#fff' : '#000'}
                  fontSize={12}
                  className="link"
                  onClick={() => setColumn(val)}
                >
                  {val}
                </Box>
              ))}
              <Box color="#404852" fontWeight="600" fontSize={14}>Columns</Box>
            </Box>
          </Box>
        </Box>

        <Box mt={2} bgcolor="#FDFDFD" borderRadius="10px" p={2}>
          {renderItems()}
        </Box>
      </div>
    </Elements.AdminPageBase>
  );
}
